import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import seatInfoFormatter from '../../utils/formatters';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItem from '@mui/material/ListItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';

function MobileDrawer({ seats, onRemove, onRemoveAll, onCancel, onContinue }) {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  return (
    <Drawer variant="permanent" anchor="bottom">
      <List sx={{ flexGrow: 1 }}>
        <ListItem>
          <Button onClick={() => setOpen(true)} disabled={!seats.length} fullWidth variant="contained">
            {`${seats.length} ${seats.length === 1 ? 'seat selected' : 'seats selected'}`}
          </Button>
        </ListItem>
      </List>
      <Dialog fullScreen={true} open={open}>
        <DialogTitle gutterBottom>
          {t('Selected seats')}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          {seats.length ? (
            <List disablePadding>
              {seats.map(
                (
                  {
                    id,
                    singleType,
                    typeId,
                    typeLabel,
                    isDefaultType,
                    section,
                    row,
                    seat,
                    categoryLabel,
                    categoryColor,
                  },
                  index
                ) => (
                  <ListItem sx={{ borderLeft: `5px solid ${categoryColor}` }} key={`${id}-${index}`} divider>
                    <ListItemText
                      sx={{ maxWidth: 200 }}
                      primary={
                        <>
                          {categoryLabel}
                          {!isDefaultType && (
                            <Chip sx={{ maxWidth: 100, marginLeft: 1 }} size="small" label={typeLabel} />
                          )}
                        </>
                      }
                      secondary={seatInfoFormatter(section, row, seat, t)}
                    />
                    <ListItemSecondaryAction>
                      <Grid container justifyItems="center" alignItems="center">
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => onRemove(id, singleType ? null : typeId)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              )}
              {!!seats.length && (
                <ListItem>
                  <Button fullWidth variant="text" size="small" onClick={onRemoveAll}>
                    {t('Clear')}
                  </Button>
                </ListItem>
              )}
            </List>
          ) : (
            <Box sx={{ height: '100%' }} display="flex" alignItems="center" justifyContent="center">
              <Typography variant="h6">{t('No seat selected')}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <List sx={{ width: '100%' }}>
            <ListItem>
              <Button disabled={!seats.length} onClick={onContinue} fullWidth variant="contained" size="big">
                {t('Continue')}
              </Button>
            </ListItem>
            <ListItem>
              <Button onClick={onCancel} fullWidth variant="outlined" size="big">
                {t('Cancel')}
              </Button>
            </ListItem>
          </List>
        </DialogActions>
      </Dialog>
    </Drawer>
  );
}

export default MobileDrawer;
